import { render, staticRenderFns } from "./LanceBenefits.vue?vue&type=template&id=0aa6d365&"
import script from "./LanceBenefits.vue?vue&type=script&lang=js&"
export * from "./LanceBenefits.vue?vue&type=script&lang=js&"
import style0 from "./LanceBenefits.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports